import React, { useState, useRef, useEffect } from "react";
import { Redirect } from "react-router-dom";
import handleToolTip from "../Utils/tooltip.js";
import { BaseUrl } from "../../App.js";
import "./ForgotPassword.css";
import Form from "../../UI/Form/Form";

const ForgotPassword = (props) => {
  const [name, setName] = useState("");
  const [state, setState] = useState({ message: "" });
  const [email, setEmail] = useState("");
  const [redirect, setRedirect] = useState(false);
  const userNameRef = useRef(null);
  const emailRef = useRef(null);

  useEffect(() => {
    userNameRef.current.focus();
  }, []);

  const firstKeyDown = (event) => {
    if (event.key === "Enter") emailRef.current.focus();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await (
      await fetch(`${BaseUrl}/forgot/password`, {
        method: "POST",
        credentials: "include", // Needed to include the cookie
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: name,
          email: email,
        }),
      })
    ).json();

    if (result.status === "success") {
      setRedirect(true);
    } else {
      setState({ message: result.error });
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "name") {
      setName(e.target.value.toUpperCase());
    } else {
      setEmail(e.target.value);
    }
  };

  handleToolTip(
    "forgot-password-tool-tip",
    "forgot-password-user-name-input",
    "forgot-password-form"
  );

  useEffect(() => {
    if (document.getElementById("forgot-password-tool-tip")) {
      const setToolTip = document.getElementById("forgot-password-tool-tip");
      if (state.message !== "") setToolTip.textContent = state.message;

      setTimeout(() => {
        setToolTip.textContent = "";
      }, 3000);
    }
  }, [state.message]);

  if (redirect) return <Redirect to="/" />;

  return (
    <React.Fragment>
      <Form
        firstInputOnKeyDown={firstKeyDown}
        firstInputValue={name}
        firstInputType="text/number"
        firstInputLabel="name"
        firstInputPlaceHolder="Username"
        firstInputRef={userNameRef}
        secondInputPlaceHolder="johndoe@gmail.com"
        secondInputType="text"
        secondInputLabel="email"
        secondInputRef={emailRef}
        secondInputValue={email}
        buttonType="submit"
        formTitle="Forgot Password"
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </React.Fragment>
  );
};

export default React.memo(ForgotPassword);
